export default __webpack_public_path__ + "static/media/newbet.f1602fb7.mp3";